<div class="course-overview p-4">
  <div class="page-heading mb-4">
    <h3>Refund Requests</h3>
  </div>
  <div class="page-heading mb-4 flex items-center justify-between">
    <div class="actions flex gap-4">
      <!-- Filter -->
      <div class="relative">
        <button (click)="dropdown(1)" class="btn-neutral">
          <svg-icon src="@assets/images/icons/filter.svg" class="btn-icon"></svg-icon>
          <span>Filter</span>
        </button>
        <div [class]="isDropdown[1] ? '':'hidden'"
          class="bg-white shadow-lg rounded px-2.5 py-5 w-[226px] absolute z-50 border border-neutral-100 max-h-80 overflow-y-auto left-0">
          <div class="flex flex-col">
            <div class="flex flex-col">
              <div class="text-base text-neutral-800 font-semibold border-b border-neutral-100 pb-2.5">
                Status
              </div>
              <app-filter-option #filterStatus key="status" [options]="filterOptions.status"
                [defaultValue]="filterValues.status" (filterEvent)="filterHander($event)">
              </app-filter-option>
            </div>
            <div class="flex flex-col">
              <div class="text-base text-neutral-800 font-semibold border-b border-neutral-100 pb-2.5">
                Refund Type
              </div>
              <app-filter-option #filterRefundType key="refund_type" [options]="filterOptions.refund_type"
                [defaultValue]="filterValues.refund_type" (filterEvent)="filterHander($event)">
              </app-filter-option>
            </div>
            <div class="flex flex-col">
              <div class="text-base text-neutral-800 font-semibold border-b border-neutral-100 pb-2.5">
                Transactions
              </div>
              <app-filter-option #filterPlatformEarning [formType]="'input'" [keyObj]="transactionsKey"
                (filterEvent)="filterHander($event)">
              </app-filter-option>
            </div>
            <div class="flex gap-2.5 border-t-neutral-100 border-t pt-4">
              <button (click)="clearFilter([filterStatus, filterRefundType, filterPlatformEarning])" type="button"
                class="btn btn-outline-dark border-neutral-600">
                <span>Reset</span>
              </button>
              <button (click)="submitFilter([filterStatus, filterRefundType, filterPlatformEarning])"
                class="btn btn-dark bg-neutral-600 text-white">
                <span>Filter</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="input-combine flex">
        <div class="select2">
          <div class="relative">
            <a (click)="dropdown(2)" type="button" aria-haspopup="listbox" aria-expanded="true"
              aria-labelledby="listbox-label" class="btn-neutral rounded-r-none">
              <div class="selected-item truncate">{{selectedItems.title}}</div>
              <svg-icon src="@assets/images/icons/chevron-down-solid.svg" class="btn-icon"></svg-icon>
            </a>
            <ul [class]="isDropdown[2]?'':'hidden'" tabindex="-1" role="listbox" aria-labelledby="listbox-label"
              aria-activedescendant="listbox-option-3" class="select-items z-50 absolute right-0 min-w-fit"
              ng-reflect-ng-class="hidden">
              @for (type of searchType; track type) {
              <li (click)="dropdown(2); selectItems(type)" id="listbox-option-0" role="option" class="item">
                {{type.title}}</li>
              }
            </ul>
          </div>
        </div>
        <div class="input-group">
          <div class="group rounded-l-none">
            <svg-icon src="@assets/images/icons/search2.svg" class="input-icon"></svg-icon>
            <input (keyup.enter)="search($event)" [placeholder]="placeholder" />
          </div>
        </div>
      </div>
      <thk-date-range-picker ngModel (ngModelChange)="filterByDate($event)" format="YYYY-MM-DD"
        placeholder="Select range date"></thk-date-range-picker>
    </div>
    <button class="btn px-6 py-3 bg-blue-50 rounded-[4px] gap-2 border-0">
      <svg-icon src="@assets/images/icons/export-icon.svg" class="text-blue-600"></svg-icon>
      <span class="text-blue-600 font-semibold text-sm">Export CSV</span>
    </button>
  </div>

  <div class="courses-list">
    <div class="card rounded-lg border border-neutral-100">
      <div class="card-subheader flex items-center justify-between px-6 py-5">
        <div class="flex items-center gap-1">
          <h6>Requests</h6>
          <div class="tag tag-sm">{{totalOrder}} Requests</div>
        </div>
        <div class="actions relative">
          <button (click)="dropdown(3)" class="btn-neutral px-2">
            <svg-icon src="@assets/images/icons/dots-vertical.svg" class="btn-icon"></svg-icon>
          </button>
          <div [class]="isDropdown[3] ? '':'hidden'"
            class="bg-white shadow-lg rounded px-2.5 py-5 w-[226px] absolute z-40 border border-neutral-100 max-h-80 overflow-y-auto right-0">
            @for (col of columns; track col; let i = $index) {
            <div class="input-check w-48 my-2">
              <input [checked]="col.visible" (change)="toggleColumn(col)" type="checkbox" id="default-checkbox-{{i}}">
              <label for="default-checkbox-{{i}}">{{col.name}}</label>
            </div>
            }
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="courses-list relative">
          @if (isLoading) {
          <div
            class="flex items-center justify-center w-full h-full left-0 right-0 absolute bg-[rgba(255,255,255,0.5)] z-20"
            [thkLibProcessing]="true"></div>
          }
          @if (refundItems.length === 0 && !isLoading) {
          <span class="text-center text-2xl my-11 block">No Refund Request Founded!</span>
          } @else {
          <ng-container *ngTemplateOutlet="listTransactions; context: { items: refundItems }">
          </ng-container>
          }
          <!-- Pagination -->
          <div class="z-30 relative">
            <app-common-pagination (paginatorData)="paginationAction($event)" (pageSize)="pageSizeAction($event)"
              [config]="paginationConfig" [type]="'dynamic'">
            </app-common-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Table -->
<ng-template #listTransactions let-items="items">
  <div class="courses-list">
    <!-- Table -->
    <div class="datagrid-table relative overflow-x-auto">
      <table class="w-full text-left">
        <thead class="heading">
          <tr>
            @for (column of columns; track column) {
            @if (column.visible) {
            <th scope="col" class="">
              <div class="col-name">{{column.name}}</div>
            </th>
            }
            }
          </tr>
        </thead>
        <tbody>
          <!-- [routerLink]="'/ecommerce/refund/'+item.id" -->
          @for (item of refundItems; track item) {
          <tr class="hover:cursor-pointer">
            @if (columns[0].visible) {
            <td>
              <span class="course-id flex items-center gap-2">
                <span (click)="showDrawer('refund', $event, item)" class="text-blue-600 underline cursor-pointer">
                  #{{ item.id }}
                </span>
                <thk-copier [content]="item.id || ''" tooltipText="Copy" copiedMessage="Copied"
                  class="btn-xs btn-white text-slate-500"></thk-copier>
              </span>
            </td>
            }
            @if (columns[1].visible) {
            <td>
              {{ item.user.fullname }}
            </td>
            }
            @if (columns[2].visible) {
            <td>
              {{ item.date_created | date }}
            </td>
            }
            @if (columns[3].visible) {
            <td class="max-w-[170px]">
              {{ item.course_progress }}%
            </td>
            }
            @if (columns[4].visible) {
            <td>
              {{ formateStatusTag(item.refund_type) }}
            </td>
            }
            @if (columns[5].visible) {
            <td>
              @if (!item.eligiblity) {
              <span class="text-red-600 text-sm font-bold">Not Eligible</span>
              }
              @if (item.eligiblity) {
              <span class="text-teal-600 text-sm font-bold">Eligible</span>
              }
            </td>
            }
            @if (columns[6].visible) {
            <td>
              @if (item.status) {
              <div class="tag tag-{{ getStatusTagColor(item.status) }} tag-sm">
                <div class="flex flex-col">
                  {{ formateStatusTag(item.status) }}
                  @if (item.status === 'approved') {
                  <span class="text-blue-600 text-sm" i18n>
                    &#64;{{item.requested_by}}
                  </span>
                  }
                </div>
              </div>
              }
            </td>
            }
            @if (columns[7].visible) {
            <td>
              {{ item.requested_by }}
            </td>
            }
            @if (columns[8].visible) {
            <td>
              {{ item.courseModeDisplay?.label }}
            </td>
            }
            @if (columns[9].visible) {
            <td>
              {{ item.approved_by.fullname }}
            </td>
            }
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</ng-template>

<!-- Buyer drawer -->
<app-drawer #refundDetailsDrawer customClass="max-w-[800px] w-full">
  <ng-container header>
    <!-- Header -->
    @if (refundItem) {
    <div class="px px-6 py-5 bg-neutral-50 flex justify-between items-center border-b border-b-neutral-100">
      <h3 class="text-xl text-black font-semibold">Refund Request Details</h3>
      <div class="flex justify-between items-center gap-3">
        <button [routerLink]="'/ecommerce/refund/'+refundItem.id"
          class="flex gap-2 flex-row px-6 py-3 rounded-[4px] font-semibold text-sm text-neutral-900 border border-neutral-600 bg-transparent">
          Go to refund detail
          <svg-icon src="@assets/images/icons/arrow-top-right-on-square.svg" class="text-blue-600 w-4 h-4">
          </svg-icon>
        </button>
        <button (click)="refundDetailsDrawer.close()" class="bg-neutral-100 rounded-[3px] w-6 h-6">
          <svg-icon src="@assets/images/icons/x-mark.svg" class="text-black w-3 h-3">
          </svg-icon>
        </button>
      </div>
    </div>
    }
  </ng-container>
  <ng-container content>
    <!-- Header -->
    <div class="w-full p-9 flex justify-between items-center">
      <h3 class="text-lg font-semibold text-black">Proceed with this refund request?</h3>
      @if (refundItem) {
      <div class="flex gap-3 items-center">
        @if (refundItem.status === 'pending') {
        @if (refundItem.eligiblity) {
        <div class="flex justify-end gap-4">
          <button (click)="refundConfirmed.open()" class="btn bg-teal-50 border-none">
            <span class="text-teal-600">Approve</span>
          </button>
          <button (click)="rejectionConfirmed.open()" class="btn btn-outline-red">
            <span>Reject</span>
          </button>
        </div>
        }
        @if (!refundItem.eligiblity) {
        <div class="flex justify-end gap-4">
          <button (click)="refundConfirmation()" class="btn bg-teal-600 border-none">
            <span class="text-white">Force Approve</span>
          </button>
          <button (click)="rejectionConfirmed.open()" class="btn btn-outline-red">
            <span>Reject</span>
          </button>
        </div>
        }
        } @else {
        <div class="flex justify-end">
          <div class="tag tag-{{ getStatusTagColor(refundItem.status) }} tag-sm">
            <span>{{formateStatusTag(refundItem.status)}}</span>
          </div>
        </div>
        }
      </div>
      }
    </div>
    @if (isLoadingDetails) {
    <div class="absolute w-full h-full flex items-center justify-center" [thkLibProcessing]="true"></div>
    } @else {
    <!-- Course Info -->
    <!-- Table -->
    @if (refundDetails) {
    <div class="px-9 py-4 flex flex-col items-start gap-2 self-stretch">
      <!-- Row -->
      <div class="flex items-start gap-3 self-stretch">
        <div class="w-40 flex items-center gap-2.5 flex-none">
          <p class="font-semibold text-base text-neutral-600 mb-0">Course Name</p>
          <svg-icon tooltip="Course Name" src="@assets/images/icons/exclamation-circle.svg"
            class="text-neutral-300 w-4 h-4">
          </svg-icon>
        </div>
        <div class="w-full flex items-center justify-start gap-2.5">
          <p class="font-normal text-base text-neutral-500 mb-0 underline">{{ refundDetails.product.title }}</p>
          <svg-icon tooltip="Course Name" src="@assets/images/icons/square-arrow-up-right-round.svg"
            class="text-neutral-300 w-4 h-4 cursor-pointer">
          </svg-icon>
        </div>
      </div>
      <div class="flex items-start gap-3 self-stretch">
        <div class="w-40 flex items-center gap-2.5 flex-none">
          <p class="font-semibold text-base text-neutral-600 mb-0">Instructor</p>
          <svg-icon tooltip="Course Name" src="@assets/images/icons/exclamation-circle.svg"
            class="text-neutral-300 w-4 h-4">
          </svg-icon>
        </div>
        <div class="w-full flex items-center justify-start gap-2.5">
          <p class="font-normal text-base text-neutral-500 mb-0 underline">{{ refundDetails.instructor.fullname }}</p>
          <svg-icon tooltip="Course Name" src="@assets/images/icons/square-arrow-up-right-round.svg"
            class="text-neutral-300 w-4 h-4 cursor-pointer">
          </svg-icon>
        </div>
      </div>
      <div class="flex items-start gap-3 self-stretch">
        <div class="w-40 flex items-center gap-2.5 flex-none">
          <p class="font-semibold text-base text-neutral-600 mb-0">Course Mode</p>
          <svg-icon tooltip="Course Type" src="@assets/images/icons/exclamation-circle.svg"
            class="text-neutral-300 w-4 h-4">
          </svg-icon>
        </div>
        <div class="w-full flex items-center justify-start gap-2.5">
          <p class="font-normal text-base text-neutral-500 mb-0 underline">{{
            refundDetails.courseModeDisplay?.label }}</p>
          <svg-icon tooltip="Course Type" src="@assets/images/icons/square-arrow-up-right-round.svg"
            class="text-neutral-300 w-4 h-4 cursor-pointer">
          </svg-icon>
        </div>
      </div>
    </div>
    }
    <!-- Summary -->
    @if (refundDetails) {
    <div class="px-9 py-4">
      <div class="flex items-start gap-11 self-stretch">
        <div class="flex flex-none flex-col gap-5">
          <h3 class="text-lg text-neutral-700 font-bold">Summary </h3>
          <!-- Table -->
          <div class="flex flex-col items-start gap-2 self-stretch">
            <!-- Row -->
            <div class="flex items-start gap-3 self-stretch">
              <div class="w-40 flex items-center gap-2.5 flex-none">
                <p class="font-semibold text-base text-neutral-600 mb-0">Eligibility</p>
                <svg-icon tooltip="Course Name" src="@assets/images/icons/exclamation-circle.svg"
                  class="text-neutral-300 w-4 h-4">
                </svg-icon>
              </div>
              <div class="w-full flex items-center justify-start gap-2.5">
                @if (!refundDetails.eligiblity) {
                <p class="text-red-600 text-base font-bold mb-0">Not Eligible</p>
                }
                @if (refundDetails.eligiblity) {
                <p class="text-teal-600 text-base font-bold mb-0">Eligible</p>
                }
              </div>
            </div>
            <div class="flex items-start gap-3 self-stretch">
              <div class="w-40 flex items-center gap-2.5 flex-none">
                <p class="font-semibold text-base text-neutral-600 mb-0">Status</p>
              </div>
              <div class="w-full flex items-center justify-start gap-2.5">
                <div class="tag tag-{{ getStatusTagColor(refundDetails.status) }} tag-sm">
                  <span>{{formateStatusTag(refundDetails.status)}}</span>
                </div>
              </div>
            </div>
            <div class="flex items-start gap-3 self-stretch">
              <div class="w-40 flex items-center gap-2.5 flex-none">
                <p class="font-semibold text-base text-neutral-600 mb-0">Requested by</p>
              </div>
              <div class="w-full flex items-center justify-start gap-2.5">
                <p class="font-bold text-base text-neutral-500 mb-0 ">{{ refundDetails.requested_by }}</p>
              </div>
            </div>
            <div class="flex items-start gap-3 self-stretch">
              <div class="w-40 flex items-center gap-2.5 flex-none">
                <p class="font-semibold text-base text-neutral-600 mb-0">Transaction ID</p>
                <svg-icon tooltip="Course Name" src="@assets/images/icons/exclamation-circle.svg"
                  class="text-neutral-300 w-4 h-4">
                </svg-icon>
              </div>
              <div class="w-full flex items-center justify-start gap-2.5">
                <p class="font-normal text-base text-neutral-500 mb-0 ">#{{ refundDetails.transaction_id }}</p>
                <svg-icon routerLink="/ecommerce/sales/transaction/{{refundDetails.transaction_id}}"
                  tooltip="Transaction ID" src="@assets/images/icons/square-arrow-up-right-round.svg"
                  class="text-neutral-300 w-4 h-4 cursor-pointer">
                </svg-icon>
              </div>
            </div>
            <div class="flex items-start gap-3 self-stretch">
              <div class="w-40 flex items-center gap-2.5 flex-none">
                <p class="font-semibold text-base text-neutral-600 mb-0">Order ID</p>
                <svg-icon tooltip="Course Name" src="@assets/images/icons/exclamation-circle.svg"
                  class="text-neutral-300 w-4 h-4">
                </svg-icon>
              </div>
              <div class="w-full flex items-center justify-start gap-2.5">
                <p class="font-normal text-base text-neutral-500 mb-0 ">#{{ refundDetails.order_id}}</p>
                <svg-icon routerLink="/ecommerce/order/{{refundDetails.order_id}}" tooltip="Order ID"
                  src="@assets/images/icons/square-arrow-up-right-round.svg"
                  class="text-neutral-300 w-4 h-4 cursor-pointer">
                </svg-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-5">
          <h3 class="text-lg text-neutral-700 font-bold">Course Progress </h3>
          <!-- Table -->
          <div class="flex flex-col items-start gap-2 self-stretch">
            <!-- Row -->
            <div class="flex items-start gap-3 self-stretch">
              <div class="w-40 flex items-center gap-2.5 flex-none">
                <p class="font-semibold text-base text-neutral-600 mb-0">Course Progress</p>
              </div>
              <div class="w-full flex items-center justify-start gap-2.5">
                <p class="font-semibold text-base text-neutral-500 mb-0 ">{{ refundDetails.course_progress }}%</p>
                <div class="w-40 h-1.5 rounded-3xl bg-neutral-200 overflow-hidden relative">
                  <span [style.width]="refundDetails.course_progress+'%'"
                    class="h-full transition-all rounded-3xl bg-neutral-700 absolute left-0">
                  </span>
                </div>
              </div>
            </div>
            <div class="flex items-start gap-3 self-stretch">
              <div class="w-40 flex items-center gap-2.5 flex-none">
                <p class="font-semibold text-base text-neutral-600 mb-0">Time Remaining </p>
              </div>
              <div class="w-full flex items-center justify-start gap-2.5">
                <p class="font-semibold text-base text-neutral-500 mb-0 ">{{ refundDetails.remaining_days }} Days</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
    <!-- Buyer Information  -->
    @if (refundDetails) {
    <div class="px-9 py-4">
      <div class="flex items-start gap-11 self-stretch">
        <div class="flex flex-none flex-col gap-5">
          <h3 class="text-lg text-neutral-700 font-bold">Buyer Information</h3>
          <!-- Table -->
          <div class="flex flex-col items-start gap-2 self-stretch">
            <!-- Row -->
            <div class="flex items-start gap-3 self-stretch">
              <div class="w-40 flex items-center gap-2.5 flex-none">
                <p class="font-semibold text-base text-neutral-600 mb-0">Buyer Name</p>
              </div>
              <div class="w-full flex items-center justify-start gap-2.5">
                <p class="font-bold text-base text-neutral-500 mb-0 ">{{ refundDetails.user.fullname }}</p>
              </div>
            </div>
            <div class="flex items-start gap-3 self-stretch">
              <div class="w-40 flex items-center gap-2.5 flex-none">
                <p class="font-semibold text-base text-neutral-600 mb-0">Purchase Date</p>
              </div>
              <div class="w-full flex items-center justify-start gap-2.5">
                <p class="font-bold text-base text-neutral-500 mb-0 ">{{ refundDetails.purchase_date | date }}</p>
              </div>
            </div>
            <div class="flex items-start gap-3 self-stretch">
              <div class="w-40 flex items-center gap-2.5 flex-none">
                <p class="font-semibold text-base text-neutral-600 mb-0">Refund Request Date</p>
              </div>
              <div class="w-full flex items-center justify-start gap-2.5">
                <p class="font-bold text-base text-neutral-500 mb-0 ">{{ refundDetails.date_created | date }}</p>
              </div>
            </div>
            <div class="flex items-start gap-3 self-stretch">
              <div class="w-40 flex items-center gap-2.5 flex-none">
                <p class="font-semibold text-base text-neutral-600 mb-0">Purchase Amount</p>
              </div>
              <div class="w-full flex items-center justify-start gap-2.5">
                <p class="font-normal text-base text-neutral-500 mb-0 ">{{ refundDetails.purchase_amount }}</p>
              </div>
            </div>
            <div class="flex items-start gap-3 self-stretch">
              <div class="w-40 flex items-center gap-2.5 flex-none">
                <p class="font-semibold text-base text-neutral-600 mb-0">Payment Method</p>
              </div>
              <div class="w-full flex items-center justify-start gap-2.5">
                <p class="font-normal text-base text-neutral-500 mb-0 ">{{
                  formateStatusTag(refundDetails.payment_method)}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-5">
          <h3 class="text-lg text-neutral-700 font-bold"></h3>
          <!-- Table -->
          <div class="flex flex-col items-start gap-8 self-stretch">
            <!-- Row -->
            <div class="flex flex-col items-start gap-1 self-stretch">
              <div class="w-40 flex items-center gap-2.5 flex-none">
                <p class="font-semibold text-base text-neutral-600 mb-0">Refund Reason </p>
              </div>
              <div class="w-full flex items-center justify-start gap-2.5">
                <p class="font-normal text-base text-neutral-500 mb-0 ">{{ refundDetails.reason }}</p>
              </div>
            </div>
            <div class="flex flex-col items-start gap-1 self-stretch">
              <div class="w-40 flex items-center gap-2.5 flex-none">
                <p class="font-semibold text-base text-neutral-600 mb-0">Description </p>
              </div>
              <div class="w-full flex items-center justify-start gap-2.5">
                <p class="font-normal text-base text-neutral-500 mb-0 ">{{ refundDetails.description }} Days</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
    <!-- Post Activities -->
    <div class="px-9 py-4 mt-14 flex flex-col items-start gap-2 self-stretch border-b border-b-slate-100">
      <h3 class="text-lg text-neutral-700 font-bold">Post Activities</h3>
    </div>
    @if (refundDetails) {
    <div class="px-9 py-4 flex flex-col items-start gap-2 self-stretch">
      <div class="flex flex-col gap-2 pl-3">
        <div class="flex flex-col gap-3 pl-8 relative">
          <div class="flex flex-row items-center gap-1">
            <h3 class="text-base font-semibold text-neutral-500">Refunded to</h3>
            <h3 class="text-base font-semibold text-neutral-800">Buyer</h3>
            <span class="w-1 h-1 rounded-full bg-neutral-200"></span>
            <p class=" mb-0 text-xs font-normal text-neutral-400">3 months ago</p>
          </div>
          <div class="flex flex-col px-6 justify-center items-center gap-1.5">
            <div class="flex items-center gap-3 self-stretch">
              <p class="text-neutral-800 font-normal text-sm mb-0 w-36">Refund Rqst. Amount:</p>
              <p class="text-neutral-500 font-normal text-sm mb-0">: $23</p>
            </div>
            <div class="flex items-center gap-3 self-stretch">
              <p class="text-neutral-800 font-normal text-sm mb-0 w-36">Refund method:</p>
              <p class="text-neutral-500 font-normal text-sm mb-0">: Paypal</p>
            </div>
          </div>
          <svg-icon src="@assets/images/icons/user-rounded.svg" class="w-6 h-6 absolute -left-[11px] top-0 z-10">
          </svg-icon>
          <span class="w-0.5 h-full bg-neutral-200 absolute left-0 top-2.5"></span>
        </div>
        <div class="flex flex-col gap-3 pl-8 relative">
          <div class="flex flex-row items-center gap-1">
            <h3 class="text-base font-semibold text-neutral-500">Refunded to</h3>
            <h3 class="text-base font-semibold text-neutral-800">Buyer</h3>
            <span class="w-1 h-1 rounded-full bg-neutral-200"></span>
            <p class=" mb-0 text-xs font-normal text-neutral-400">3 months ago</p>
          </div>
          <div class="flex flex-col px-6 justify-center items-center gap-1.5">
            <div class="flex items-center gap-3 self-stretch">
              <p class="text-neutral-800 font-normal text-sm mb-0 w-36">Refund Rqst. Amount:</p>
              <p class="text-neutral-500 font-normal text-sm mb-0">: $23</p>
            </div>
            <div class="flex items-center gap-3 self-stretch">
              <p class="text-neutral-800 font-normal text-sm mb-0 w-36">Refund method:</p>
              <p class="text-neutral-500 font-normal text-sm mb-0">: Paypal</p>
            </div>
          </div>
          <svg-icon src="@assets/images/icons/user-rounded.svg" class="w-6 h-6 absolute -left-[11px] top-0 z-10">
          </svg-icon>
          <span class="w-0.5 h-full bg-neutral-200 absolute left-0 top-2.5"></span>
        </div>
        <div class="flex flex-col gap-3 pl-8 relative">
          <div class="flex flex-row items-center gap-1">
            <h3 class="text-base font-semibold text-neutral-500">Refunded to</h3>
            <h3 class="text-base font-semibold text-neutral-800">Buyer</h3>
            <span class="w-1 h-1 rounded-full bg-neutral-200"></span>
            <p class=" mb-0 text-xs font-normal text-neutral-400">3 months ago</p>
          </div>
          <div class="flex flex-col px-6 justify-center items-center gap-1.5">
            <div class="flex items-center gap-3 self-stretch">
              <p class="text-neutral-800 font-normal text-sm mb-0 w-36">Refund Rqst. Amount:</p>
              <p class="text-neutral-500 font-normal text-sm mb-0">: $23</p>
            </div>
            <div class="flex items-center gap-3 self-stretch">
              <p class="text-neutral-800 font-normal text-sm mb-0 w-36">Refund method:</p>
              <p class="text-neutral-500 font-normal text-sm mb-0">: Paypal</p>
            </div>
          </div>
          <svg-icon src="@assets/images/icons/user-rounded.svg" class="w-6 h-6 absolute -left-[11px] top-0 z-10">
          </svg-icon>
        </div>
      </div>
    </div>
    }
    }
  </ng-container>
</app-drawer>


<!-- Refund confirm modal -->
<common-modal #refundConfirmed customClass="sm:w-full sm:max-w-[535px] rounded-none">
  <ng-container header>
    <div class="p-6 flex flex-row gap-4 justify-between border-b border-neutral-100">
      <div class="form max-w-4xl">
        <h1 class="text-black font-semibold text-xl">Refund Confirmation?</h1>
      </div>
      <button (click)="refundConfirmed.close()" class="text-slate-500 hover:text-slate-800 w-4">
        <svg-icon src="@assets/images/icons/x-mark.svg" class="w-4"></svg-icon>
      </button>
    </div>
  </ng-container>
  <ng-container content>
    <p class="text-base text-slate-900 p-6 mb-0">Are you sure want to refund this course?</p>
  </ng-container>
  <ng-container footer>
    <div class="px-[30px] py-5 flex flex-col items-end border-t border-neutral-100">
      <div class="flex gap-4">
        <button (click)="refundConfirmed.close()" class="btn bg-neutral-100 border-none">
          <span class="text-neutral-900 text-sm font-semibold">Cancel</span>
        </button>
        <button (click)="confirmRefund()" class="btn bg-teal-600 border-none">
          <span class="text-white text-sm font-semibold">Confirm</span>
        </button>
      </div>
    </div>
  </ng-container>
</common-modal>

<!-- Rejection confirm modal -->
<common-modal #rejectionConfirmed customClass="sm:w-full sm:max-w-[788px] rounded-none">
  <ng-container header>
    <div class="p-6 flex flex-row gap-4 justify-between border-b border-neutral-100">
      <div class="form max-w-4xl">
        <h1 class="text-black font-semibold text-xl">Rejectional Reason</h1>
      </div>
      <button (click)="rejectionConfirmed.close()" class="text-slate-500 hover:text-slate-800 w-4">
        <svg-icon src="@assets/images/icons/x-mark.svg" class="w-4"></svg-icon>
      </button>
    </div>
  </ng-container>
  <ng-container content>
    <div class="px-6 py-5 border-b border-b-neutral-100">
      <div class="form">
        <form [formGroup]="rejectReasonForm">
          <formly-form [form]="rejectReasonForm" [fields]="rejectReasonFormFields" [model]="rejectReasonFormModel">
          </formly-form>
        </form>
      </div>
    </div>
  </ng-container>
  <ng-container footer>
    <div class="px-[30px] py-5 flex flex-col items-end border-t border-neutral-100">
      <div class="flex gap-4">
        <button (click)="rejectionConfirmed.close()" class="btn bg-neutral-100 border-none">
          <span class="text-neutral-900 text-sm font-semibold" i18n>Cancel</span>
        </button>
        <button (click)="confirmRejection()" [disabled]="rejectReasonForm.invalid" class="btn bg-teal-600 border-none">
          <span class="text-white text-sm font-semibold" i18n>Confirm</span>
        </button>
      </div>
    </div>
  </ng-container>
</common-modal>